export default __webpack_public_path__ + "static/media/culture_title.e34849a0.png";